import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31t-127-86q-54-54-85-127T80-480q0-83 32-156t85-127q54-54 127-85t156-32q83 0 156 32t127 85q54 54 86 127t31 156q0 83-31 156t-86 127q-54 54-127 86T480-80Zm0-400Zm0 320q133 0 227-93t93-227q0-133-93-226t-227-94q-133 0-226 94t-94 226q0 133 94 227t226 93Z"/>',
  f: '<path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31t-127-86q-54-54-85-127T80-480q0-83 32-156t85-127q54-54 127-85t156-32q83 0 156 32t127 85q54 54 86 127t31 156q0 83-31 156t-86 127q-54 54-127 86T480-80Z"/>',
  rao: { fill: '#e8eaed' },
  raf: { fill: '#e8eaed' },
};

export default data;
